"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flower = void 0;
const gotti_1 = require("gotti");
const Position_1 = require("../../Shared/Components/Position");
const Component_1 = require("../Systems/Flower/Component");
const types_1 = require("../../Shared/types");
const GameData_1 = require("../../Shared/GameData");
class Flower extends gotti_1.Entity {
    constructor(data) {
        super(data.uid, types_1.ItemTypes.FLOWER);
        this.flowerType = data.name;
        this.seedType = this.flowerType.replace('flower', 'seeds');
        this.initializedState = data;
    }
    get isFullyGrown() {
        return this.flowerComponent.grownState === "flower";
    }
    initialize(type) {
        const { x, y, state } = this.initializedState;
        this.addComponent(new Position_1.Position(x, y));
        this.flowerComponent = new Component_1.FlowerComponent(state, GameData_1.PlatableGameData[this.seedType].timeToGrow);
        this.addComponent(this.flowerComponent);
    }
    get timeAlive() {
        return this.flowerComponent.state.elapsedTimeAlive;
    }
}
exports.Flower = Flower;
//# sourceMappingURL=module.js.map